export default __webpack_public_path__ + "static/media/1RzFW7qm7zfz9oOn8RAsX7vtOvi1.cdc98c4a.jpg";